<template>
    <div class="list-turma">

        <c-panel>      
            
            <el-form label-position="top" class="u-mb-30">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingTurmas" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="table-turmas container-table" v-if="statusList && Object.keys(items).length > 0">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="hidden-mobile u-text-center"><b>TURNO</b></th>
                            <th class="u-text-right"><b>SITUAÇÃO / AÇÃO</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(cursos, m) in items">
                            <tr :key="m">
                                <td class="titleTurma" colspan="100%">{{ m }}</td>
                            </tr>
                            <template v-for="(turmas, i) in cursos">
                                <tr :key="turmas.id">
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}"><span style="margin-left: 30px;"><b>TURMA:</b> {{ turmas.nome }}</span></td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-center">{{ $CONSTANTS.TURNO[turmas.turno] }}</td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="u-text-right" style="padding-right: 0;">
                                        

                                        <el-popover class="u-mr-5" v-if="$store.state.user.tipo == 6 && turmas.fase_diario != 1 && turmas.fase_diario != 2" placement="left" style="margin-left: 10px;">
                                            <ul class="list-acoes">                                               
                                                

                                                <li v-if="turmas.metodo_avaliacao == 'quantitativo' && turmas.fase_diario == 5" @click="retornarFase(4, turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Retornar para o conselho final
                                                </li>

                                                <li v-if="turmas.metodo_avaliacao == 'quantitativo' && (turmas.fase_diario == 4 || turmas.fase_diario == 3)" @click="retornarFase(2, turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Retornar para o conselho parcial
                                                </li>
                                            
                                                <li v-if="turmas.metodo_avaliacao == 'qualitativo' && turmas.fase_diario == 5" @click="retornarFase(1, turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Reabrir diário
                                                </li>
                                                
                                            </ul>
                                            <el-button slot="reference" title="Mais ações"  icon="el-icon-menu" size="mini" type="danger"></el-button>
                                        </el-popover>  

                                        <el-button type="primary" title="Situação do diário" size="mini" style="width: 232px; cursor: default;">
                                            {{ $CONSTANTS.FASE_DIARIO[turmas.fase_diario] }}
                                        </el-button>

                                        <el-popover v-if="turmas.fase_diario != 5" placement="left" style="margin-left: 10px;">
                                            <ul class="list-acoes">
                                                
                                                <li v-if="turmas.fase_diario == 1 && turmas.metodo_avaliacao == 'quantitativo'" @click="iniciarConselhoParcial(turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Iniciar Conselho de Classe Parcial
                                                </li>
                                                <li v-if="turmas.fase_diario == 2 && turmas.metodo_avaliacao == 'quantitativo'" @click="encerrarConselhoParcial(turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Encerrar Conselho de Classe Parcial
                                                </li>
                                                <li v-if="turmas.fase_diario == 3 && turmas.metodo_avaliacao == 'quantitativo'" @click="iniciarConselhoFinal(turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Iniciar Conselho de Classe Final
                                                </li>                                                
                                                <li v-if="turmas.fase_diario == 4 || (turmas.fase_diario == 1 && turmas.metodo_avaliacao == 'qualitativo')" @click="encerrarDiario(turmas)">
                                                    <i class="vsm-icon far fa-id-card"></i>
                                                    Fechar Diário
                                                </li>
                                                
                                            </ul>
                                            <el-button :disabled="$store.state.user.tipo == 7" slot="reference" title="Mais ações"  icon="el-icon-menu" size="mini" :type="turmas.fase_diario != 5 ? 'primary' : 'warning'" plain></el-button>
                                        </el-popover>

                                        <el-button v-if="turmas.fase_diario == 5" @click="printDiario(turmas)" type="success" title="Imprimir diário" size="mini" style="margin-left: 10px;">
                                            <i class="fas fa-print"></i>
                                        </el-button>

                                        <el-button :disabled="turmas.fase_diario == 5" @click="printDiarioSituacaoAcademica(turmas)" type="warning" title="Imprimir situações acadêmcas" size="mini" style="margin-left: 10px;">
                                            <i class="fas fa-print"></i>
                                        </el-button>                                       

                                        <router-link :to="'/admin/diario/fechamento/'+ turmas.id" style="margin-left: 10px;">
                                            <el-button type="primary" title="Visualizar detalhes" icon="el-icon-search" size="mini"></el-button>
                                        </router-link>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>

            <div v-if="!statusList" class="u-text-center" style="margin-top: 50px; margin-bottom: 50px;">
                <hr>
                    <img class="u-mt-10 u-mb-10" src="/public/img/loading-bar.gif" />
                <hr>
            </div>

            <div v-if="statusList && filtro.instituicao.id && Object.keys(items).length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">nenhuma turma cadastrada</h4>
            </div>

            <div v-if="statusList && !filtro.instituicao.id && Object.keys(items).length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">selecione uma instituição</h4>
            </div>

        </c-panel>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: true,
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            },
            periodo: {
                id: '',
                nome: ''
            },
        },
        items: {}

    }),
    mounted(){

        this.filtro.periodo.id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if(this.$store.state.config.instituicao){

            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadingTurmas();
    },
    methods: {
        retornarFase(fase, turma){

            this.$msgbox.confirm('Tem certeza que deseja alterar a fase do diário desta turma?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning', dangerouslyUseHTMLString: true, type: '' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    turma_id: turma.id,
                    fase: fase
                };
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/updateFase`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', { confirmButtonText: 'OK' });
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.loadingTurmas();

                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        loadingTurmas(){

            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id || !this.filtro.periodo.id){

                return false;
            }

            let i = this.$store.state.config.instituicao.id;
            let p = 11; //this.filtro.periodo.id;

            this.statusList = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListTurmas/` + i + '/' + p, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        iniciarConselhoParcial(turma) {
            
            this.$msgbox.confirm('Tem certeza que deseja iniciar o Conselho de Classe Parcial?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning', dangerouslyUseHTMLString: true, type: '' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    turma_id: turma.id
                };
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/iniciarConselhoParcial`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', { confirmButtonText: 'OK' });
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$router.push(`/admin/diario/fechamento/${turma.id}`);

                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },  
        encerrarConselhoParcial(turma) {
            
            let textoConfirm = `Após o encerramento do conselho de classe parcial, não será possível realizar lançamento de notas de trimestres para esta turma.<br> Apenas será possível realizar o lançamento de notas de recuperação.<br>Tem certeza que deseja encerrar o Conselho de Classe parcial?`;

            this.$msgbox.confirm(textoConfirm, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning', dangerouslyUseHTMLString: true, type: '' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    turma_id: turma.id
                };
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/encerrarConselhoParcial`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', { confirmButtonText: 'OK' });
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.loadingTurmas();
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },  
        iniciarConselhoFinal(turma) {
            
            let textoConfirm = `O conselho final deve ser iniciado ao final do período de recuperação.<br>Tem certeza que deseja iniciar o Conselho de Classe Final?`;

            this.$msgbox.confirm(textoConfirm, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning', dangerouslyUseHTMLString: true, type: '' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    turma_id: turma.id
                };
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/iniciarConselhoFinal`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', { confirmButtonText: 'OK' });
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$router.push(`/admin/diario/fechamento/${turma.id}`);
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },  
        encerrarDiario(turma) {
            
            let textoConfirm = `Após o fechamento do diário, as situações acadêmicas dos alunos serão definitivas.<br>Tem certeza que deseja fechar o diário?`;

            this.$msgbox.confirm(textoConfirm, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning', dangerouslyUseHTMLString: true, type: '' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    turma_id: turma.id
                };
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/encerrarDiario`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', { confirmButtonText: 'OK' });
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.loadingTurmas();
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        printDiario(turma) {

            let filtro = {
                turma_id: turma.id
            }

            window.eventBus.$emit('print', {url: '/api/pdf/renderDiarioEncerrado/pdf', param: { filtros: filtro }});
        },
        printDiarioSituacaoAcademica(turma) {

            let filtro = {
                turma_id: turma.id
            }

            window.eventBus.$emit('print', {url: '/api/pdf/renderDiarioSituacaoAcademica/pdf', param: { filtros: filtro }});
        },
    },
    components:{  }
}
</script>
<style>

    .table-turmas .table th, .table-turmas .table td {
        padding: 5px 10px;
    }

    .list-turma .list-turno{
        padding-left: 0px;
    }

    .titulo-curso{

        background-color: #e8e8e8;
        margin-top: 25px;
        padding: 5px 20px;
        display: block;
    }

    .list-cursos{
        padding-left: 15px;
    }

    .list-turmas{

        margin-top: 10px;
        display: block;
    }

    .instituicao .container-list-turmas{
        text-transform: uppercase;
    }

    .row-turma{
        border-bottom: 1px solid #ccc;
    }


</style>